import { WordpressDeveloperView } from '../../views';
export default WordpressDeveloperView;
